var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center" },
    [
      _c("FormDatepicker", {
        staticClass: "w-full",
        attrs: {
          value: _vm.start,
          calendarClass: "right-0 xl:left-0",
          label: "",
          placeholder: "start",
        },
        on: { input: _vm.handleStartInput },
      }),
      _c("p", { staticClass: "mx-2" }, [_vm._v(" - ")]),
      _c("FormDatepicker", {
        staticClass: "w-full",
        attrs: {
          value: _vm.end,
          calendarClass: "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
          label: "",
          placeholder: "end",
        },
        on: { input: _vm.handleEndInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }